// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".one-sidebar[data-v-8989e072]{max-width:0;display:block;overflow:hidden;-webkit-transition:max-height .25s ease-out;-webkit-transition:max-width .25s ease-out;transition:max-width .25s ease-out}.one-sidebar__element[data-v-8989e072]{overflow:auto}.show[data-v-8989e072]{max-width:600px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
